import { useTranslation } from 'react-i18next';

import { Button } from '../buttons/Button';
import { Widget } from '../widget/Widget';

import styles from './disclaimerWidget.module.scss';

export type DisclaimerWidgetProps = {
  title?: string;
  content?: string;
  isLoading?: boolean;
  onCancel?: () => void;
  onAccept?: () => void;
};

function DisclaimerWidgetContent({
  content,
  onAccept,
  onCancel,
}: Pick<DisclaimerWidgetProps, 'content' | 'onCancel' | 'onAccept'>) {
  const { t } = useTranslation();
  return (
    <div className={styles['content']}>
      <p style={{ whiteSpace: 'pre-wrap' }}>{content}</p>
      <div className={styles['buttons']}>
        <Button enlarge onClick={onCancel} variant="secondary">
          {t('app.disclaimer.cancel')}
        </Button>
        <Button enlarge onClick={onAccept} variant="primary">
          {t('app.disclaimer.accept')}
        </Button>
      </div>
    </div>
  );
}

export function DisclaimerWidget({
  title,
  content,
  onCancel,
  onAccept,
}: DisclaimerWidgetProps) {
  const { t } = useTranslation();
  return (
    <div className={styles['root']}>
      <Widget title={title || t('app.disclaimer.defaultTitle')}>
        <DisclaimerWidgetContent
          content={content}
          onCancel={onCancel}
          onAccept={onAccept}
        />
      </Widget>
    </div>
  );
}
